// Petit personnage mascotte (un livre à visage) pour les états vides.
// variant: 'happy' (collection vide) | 'search' (aucun résultat) | 'sparkle' (souhaits vides)
export default function Mascot({ variant = 'happy', size = 96 }) {
  const accessory = { search: '🔍', sparkle: '✨', happy: null }[variant];
  const mouth = variant === 'search'
    ? <ellipse cx="60" cy="76" rx="7" ry="5" fill="#1C1612"/>
    : <path d="M52 75 Q60 83 68 75" stroke="#1C1612" strokeWidth="3.5" fill="none" strokeLinecap="round"/>;

  return (
    <div style={{ position:'relative', width:size, height:size, margin:'0 auto 14px', animation:'mascotBob 2.6s ease-in-out infinite' }}>
      <svg viewBox="0 0 100 100" width={size} height={size}>
        <ellipse cx="54" cy="95" rx="30" ry="6" fill="#1C1612" opacity=".08"/>
        <rect x="18" y="12" width="64" height="78" rx="15" fill="#F04E1A"/>
        <rect x="18" y="12" width="15" height="78" rx="15" fill="#C83E12"/>
        <rect x="41" y="28" width="35" height="5.5" rx="2.75" fill="#FFD9C7"/>
        <rect x="41" y="40" width="26" height="5.5" rx="2.75" fill="#FFD9C7"/>
        <circle cx="52" cy="62" r="4.5" fill="#1C1612"/>
        <circle cx="68" cy="62" r="4.5" fill="#1C1612"/>
        {mouth}
      </svg>
      {accessory && (
        <div style={{ position:'absolute', bottom:'-2px', right:'-8px', fontSize: size*0.34 }}>{accessory}</div>
      )}
      <style>{`@keyframes mascotBob{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}`}</style>
    </div>
  );
}
